import styled, { css, keyframes } from 'styled-components';
import LogoIcon from 'assets/icons/character.svg';

const waveAnimation = keyframes`
  from { left: -400px; }
  to { left: 400px; }
`;

export const FallbackLogoIcon = styled.div<{ $width?: string; $height?: string; $margin?: string }>`
  margin-left: 500px;
  margin: ${({ $margin }) => $margin ?? '50px'};
  display: block;
  mask-size: cover;
  mask-image: url(${LogoIcon});
  background-color: #ddd;
  position: relative;

  width: ${({ $width }) => $width ?? '288px'};
  height: ${({ $height }) => $height ?? '284px'};

  ${({ theme }) => css`
    ${theme.breakpoints.down('sm')} {
      width: 192px;
      height: 189px;
    }
  `}

  ::before {
    content: '';
    display: block;
    top: -50px;
    width: 50px;
    height: calc(100% + 100px);
    position: relative;
    filter: blur(50px);
    transform: rotate(45deg);
    animation: ${waveAnimation} 1000ms ease infinite;
    background-color: ${({ theme }) => theme.palette.common.black};
  }

  will-change: filter;
`;

export const TopSpacedContainer = styled.main`
  height: 80%;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
`;
